module.exports = __webpack_public_path__ + "static/media/ArialCEItalic.7488a3d7.ttf";